/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Faq_Free_QInputs */

const en_gc_resources_faq_free_q = /** @type {(inputs: Gc_Resources_Faq_Free_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is GridCraft ArtCraft free?`)
};

const zh_gc_resources_faq_free_q = /** @type {(inputs: Gc_Resources_Faq_Free_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft ArtCraft 免费吗？`)
};

/**
* | output |
* | --- |
* | "Is GridCraft ArtCraft free?" |
*
* @param {Gc_Resources_Faq_Free_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_faq_free_q = /** @type {((inputs?: Gc_Resources_Faq_Free_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Faq_Free_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_faq_free_q(inputs)
	return zh_gc_resources_faq_free_q(inputs)
});
export { gc_resources_faq_free_q as "gc.resources.faq.free.q" }